// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__CASix","text":"Empty_text__EZmvS"};